import { mapState } from 'vuex'

const ShoppingCartToggle = {
  // Data
  data () {
    return {
      isActive: false
    }
  },
  // Computed
  computed: {
    ...mapState({
      quantity: state => state.cart.totalItems
    }),
  },
  // Methods
  methods: {
    setActiveState: function(toggleValue) {
      this.isActive = toggleValue
    },
    handleClick: function() {
      this.setActiveState(!this.isActive)
      bus.$emit('shopping_cart_toggle', this.isActive)
      bus.$emit('toggle_header_search', 'close')
    }
  },
  created () {
    bus.$on('shopping_cart', (isActive) => {
      this.setActiveState(isActive)
    })
  },
}

export default ShoppingCartToggle
